/*
|--------------------------------------------------------------------------
| Helper: formatCurrency.js
| Author: Sayed Ahmed
| Description: Formats a number with site currency and localized comma.
|--------------------------------------------------------------------------
*/

import { getSiteSetting } from "./getSiteSetting";

/**
 * Formats a given number with currency
 * 
 * @param {number|string} amount - Value to format
 * @param {string} fallbackCurrency - Optional fallback currency
 * @returns {string} - Formatted currency string
 */
export function formatCurrency(amount, fallbackCurrency = "EG") {
  const currency = getSiteSetting("site_global_currency", fallbackCurrency);

  if (amount == null || isNaN(amount)) return `0 ${currency}`;
  
  return `${Number(amount).toLocaleString()} ${currency}`;
}
